import { PlaType } from '@ikegps/core-api';

/** PLA-bearing metadata flags, as found on {@link FormMetadata} or a form's metadata options. */
export interface PlaTypeMetadataOptions {
	spidacalc?: unknown;
	ocalc?: unknown;
	poleforeman?: unknown;
	ikePoleForeman?: unknown;
	dds?: unknown;
	quickpole?: unknown;
}

/**
 * Derive the {@link PlaType} from a form's metadata options, or `null` for a base
 * (non-PLA) form. Order is significant and matches historical classification.
 */
export function plaTypeFromMetadata(options: PlaTypeMetadataOptions | null | undefined): PlaType | null {
	if (!options) {
		return null;
	}
	if (options.spidacalc) {
		return PlaType.SPIDACALC;
	}
	if (options.ocalc) {
		return PlaType.OCALC;
	}
	if (options.poleforeman) {
		return PlaType.POLEFOREMAN;
	}
	if (options.ikePoleForeman) {
		return PlaType.IPF;
	}
	if (options.dds) {
		return PlaType.DDS;
	}
	if (options.quickpole) {
		return PlaType.QUICKPOLE;
	}
	return null;
}
